import React, { useEffect } from 'react';
import { ModelType } from '@packages/global';
import { useModels } from '../../hooks/useModels';
import { useCreativeChatStore } from '../../stores/creativeChatStore';
import CompactModelSelector from '../common/form/CompactModelSelector';

const CreativeChatModelSelector: React.FC = () => {
  const { models, loading } = useModels(ModelType.LLM);
  const { selectedModelId, setSelectedModelId, isGenerating } = useCreativeChatStore();

  useEffect(() => {
    if (!loading && models.length > 0 && !selectedModelId) {
      setSelectedModelId(models[0].id);
    }
  }, [loading, models, selectedModelId, setSelectedModelId]);

  return (
    <div className="w-44 [&_label]:hidden">
      <CompactModelSelector
        label=""
        models={models}
        value={selectedModelId || ''}
        onChange={setSelectedModelId}
        disabled={isGenerating}
      />
    </div>
  );
};

export default CreativeChatModelSelector;
